import HomepageDivider from './HomepageDivider';

export default HomepageDivider